// Store related actions
export const SET_CURRENT_STORE = 'SET_CURRENT_STORE';
export const SET_STORES_FETCHED = 'SET_STORES_FETCHED';
export const SET_STORES = 'SET_STORES';
export const CLEAR_STORES = 'CLEAR_STORES';

export const setCurrentStore = (store) => {
  return {
    type: SET_CURRENT_STORE,
    payload: store
  };
};

export const setStoresFetched = (fetched) => {
  return {
    type: SET_STORES_FETCHED,
    payload: fetched
  };
};

export const setStores = (stores) => {
  return {
    type: SET_STORES,
    payload: stores
  };
};
